import { defineStore } from "pinia";

import { StateNamespace } from "@/Modules/App/Models/State/StateNamespace";
import type { I18nState } from "./Model/Interfaces";
import type { Language } from "@/Common/Models/Domain/Language";
import type { Translations } from "./Model/Domain";

import FetchLocaleActionHandler from "./ActionHandlers/FetchLocale";
import FetchLocalesActionHandler from "./ActionHandlers/FetchLocales";
import SelectLocaleActionHandler from "./ActionHandlers/SelectLocale";
import GetCurrentLocaleActionHandler from "./ActionHandlers/GetCurrentLocale";
import CheckLocaleVersionActionHandler from "./ActionHandlers/CheckLocaleVersion";

const state: I18nState = {
  isLoading: false,
  locale: undefined,
  locales: new Map(),
};

export const useI18nStore = defineStore(StateNamespace.I18N, {
  state: () => ({ ...state }),
  getters: {
    translations(state: I18nState): Translations | undefined {
      return state.locales.get(state.locale!)?.translations;
    },
  },
  actions: {
    fetchLocale(l: Language) {
      return FetchLocaleActionHandler(l);
    },

    fetchLocales() {
      return FetchLocalesActionHandler();
    },

    selectLocale(l: Language, force: boolean = false) {
      return SelectLocaleActionHandler(l, force);
    },

    getCurrentLocale() {
      return GetCurrentLocaleActionHandler();
    },

    checkLocaleVersion(l?: Language) {
      return CheckLocaleVersionActionHandler(l);
    },
  },
});

export type I18nStore = ReturnType<typeof useI18nStore>;

export default useI18nStore;
